import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "searchBox",
  ref: "searchRef"
}
const _hoisted_2 = { style: {"margin-bottom":"115px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_btn = _resolveComponent("search-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "searchTitle" }, "欢迎访问AWS PaaS帮助中心", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_search_btn, { onSearchValue: _ctx.searchValue }, null, 8, ["onSearchValue"])
    ])
  ], 512))
}